export const isNewEntry = (tags) => {
  if (!tags || !tags.length) return false;

  return tags.indexOf('Neu') !== -1 || tags.indexOf('Update') !== -1;
};
